(function() {
  'use strict';
  angular.module('common')
  .directive('submitOnEnter', [function() {
	/* Handle multiple submits. The first enabled will be submitted. Add it to the form or a parent element */
    let keycodeEnter = 13;
    return {
      restrict: 'A',
      link: function($scope, elem, attrs) {
          elem.on("keypress", function($event) {
            if ($event.which === keycodeEnter) {
              let buttons = elem.find('button[type=submit]:enabled, input[type=submit]:enabled');
              if (buttons.length > 0) {
            	  $event.preventDefault();            	 
            	  buttons[0].click();
              }
            }
          });
      }
    };
  }]);
})();
